module.exports = __webpack_public_path__ + "img/S_5485_ordering.0789938f.jpg";